document.addEventListener("DOMContentLoaded", () => {

  const seen = JSON.parse(localStorage.getItem("seenNotifications") || "[]");
  
  const updateNotifications = () => {
        let count = 0;
        const addedNotifications = []
        document.querySelectorAll(".oddballs-notification-wrapper").forEach(wrapper => {
            const id = wrapper.dataset.metaobjectId;
            
            if (seen.includes(id)) {
                wrapper.classList.add("notification-seen");
            }else{
                if(!addedNotifications.includes(id)){
                    addedNotifications.push(id);
                    console.log(wrapper)
                    count += 1;
                }
            }
            const notificationIcons = document.querySelectorAll(".notification-count")
            Array.from(notificationIcons).forEach((icon)=>{
                icon.innerHTML = count;
                if(count != 0 ){
                    icon.style.display = "flex";
                }
            })
        });

        const recentlyViewed = JSON.parse(localStorage.getItem("oddballs-notifications-recently-viewed")) || [];
        console.log(recentlyViewed)
        const recentlyViewedTitle = document.querySelector(".recently-viewed-title");
        recentlyViewedTitle.style.display = recentlyViewed.length == 0 ? "none" : "block"
        const recentlyViewedContainers = document.querySelectorAll(".oddballs-notifications-recently-viewed-container");
        recentlyViewedContainers.forEach((container)=>{
            container.innerHTML = "";
            recentlyViewed.forEach((product)=>{
                const wrapper = document.createElement("a");
                wrapper.href = product.url
                wrapper.className = "oddballs-notifications-recently-viewed-product";
                const img = document.createElement("img");
                img.src = product.image.replace(".png", "_80x.png").replace(".jpg", "_80x.jpg");
                wrapper.append(img)
                container.append(wrapper)
            })
        })
    }

    document.addEventListener("click", (e) => {
        const wrapper = e.target.closest(".oddballs-notification-wrapper");
        if (!wrapper) return;
        
        const id = wrapper.dataset.metaobjectId;
        
        const updated = [...seen, id];
        localStorage.setItem("seenNotifications", JSON.stringify(updated));
        
        wrapper.classList.add("notification-seen");
        updateNotifications();
    }); 
    updateNotifications();

});